export default __webpack_public_path__ + "static/media/checkBoxFail.828dc438.svg";